module.exports = __webpack_public_path__ + "img/5.65e185bb.webp";